import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门爆料榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网吃瓜群众正在围观的51吃瓜今日黑料，热度实时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 hover:bg-background-100 rounded-xl transition-colors border border-background-200/70 group cursor-pointer"
            >
              <div
                className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-heading text-lg ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                  <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mr-2 align-middle">
                    {item.tag}
                  </span>
                  {item.title}
                </h3>
              </div>

              <div className="flex-shrink-0 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500"></i>
                  {item.heat}
                </span>
                <span className="hidden sm:inline">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}